import React from 'react'
import Switch from "react-switch";

import {
  getCarData as carData,
  getColorsData as colorsData,
  getSceneData as sceneData,
  getFichasData as fichasData,
  getCotizaData as cotizaData,
  getConfigData,
  getCarDisplayName,
  getVersionDisplayName
} from '../../helpers/strapi.helper';
import { optionsData } from '../../data/options.data';
import { fichasNameData } from '../../data/fichas_name.data';

import arrowBtn from './../../UI/general/Icon_Show-Hide.svg'
// import doubleArrowBtn from './../../UI/general/arrow_btn.svg'
import logoUmbra from './../../UI/LogoUmbra.svg'
import GETWebParams from '../../helpers/GETWebParams';
const params = GETWebParams()

declare const window: any;

interface Props {
  openScene: boolean,
  currentCarSelected: string,
  handleTurnOffLigths: (payload: boolean) => void,
  handleCompleteCar: (payload: string) => void,
  handleChangeColor: (payload: string) => void,
  handleShowInterior: (payload: boolean) => void 
  handleChangeSeat: (payload: string) => void
  handleShowBullets: (payload: boolean) => void
  handleShowBulletsInterior: (payload: boolean) => void
  handleChangeScene: (payload: any) => void
  handleShowVideo: (payload: boolean) => void
  showVideo: boolean,
  handleIsVideoOpened: (payload: boolean) => void
  handleIsPlayingAnimation: (payload: boolean) => void
  isPlayingAnimation: boolean,
  handleCloseCarStudio: () => void,
  handleSelectModel: (payload: string) => void
  handleQuotation: (payload: boolean) => void
  isQuotationOpened: boolean
  showLigths: boolean
  showInteriorLights: boolean
  handleShowLigths: (payload: boolean) => void
  handleShowInteriorLights: (payload: boolean) => void
  handleCollapse: (payload: boolean) => void
  handleCarStudioFromQuotation: (payload: boolean) => void
  isCarStudioClosedQuotation: boolean,
  handleShowPDF: (payload: boolean) => void
  firstLoadedWebParams: boolean,
  handleFirstWebParams: (payload: boolean) => void,
  enableInternalCotizaGlobally: boolean,
}

interface State {
  versionsToShow: any,
  colorsToShow: any,
  scenesData: any
  carData: any,
  currentEditionSelected: string,
  showViews: boolean,
  seatRows: number,
  showBullets: boolean,
  currentSelectedVista: number,
  isCollapsed: boolean,
  currentColorSelected: string,
  optionsData: any,
  currentVersionSelected: string,
  currentSeatSelected: number,
  currentSceneSelected: number,
  fichasData: any,
  showArrow: boolean,
  disableSceneButtons: boolean,
  disableColorButtons: boolean,
  disableExteriorSwitchLights: boolean,
  disableInteriorSwitchLights: boolean,
}

class CarStudioUI extends React.Component<Props,State>{
  constructor(props: Props){
    super(props);
    this.state = {
      versionsToShow: [],
      colorsToShow: [],
      scenesData: [],
      carData: {},
      currentEditionSelected: "",
      showViews: true,
      seatRows: 1,
      showBullets: false,
      currentSelectedVista: 0,
      isCollapsed: false,
      currentColorSelected: '',
      optionsData: {},
      currentVersionSelected: '',
      currentSeatSelected: 0,
      currentSceneSelected: 0,
      fichasData: 0,
      showArrow: true,
      disableSceneButtons: false,
      disableColorButtons: false,
      disableExteriorSwitchLights: false,
      disableInteriorSwitchLights: false,
    }
  }

  componentDidMount(): void {
    this.setState({
      carData: carData()
    }, () => {
      this.setState({
        versionsToShow: this.state.carData[this.props.currentCarSelected],
      }, () => {
        
        this.setState({
          currentEditionSelected: this.props.currentCarSelected +" "+ Object.keys(this.state.versionsToShow)[0]
        }, () => {
          var colors: any = colorsData()
          var options: any = optionsData()
          var scenes: any = sceneData(this.state.currentEditionSelected)
          var params: any = GETWebParams()

          this.props.handleCompleteCar(this.state.currentEditionSelected)

          let defaultSceneIndex = 0;
          let defaultSceneObj: any = null;
          if (scenes && Object.keys(scenes).length > 0) {
            const keys = Object.keys(scenes);
            const defKey = keys.find(k => scenes[k].default === true) || keys[0];
            defaultSceneIndex = keys.indexOf(defKey);
            defaultSceneObj = scenes[defKey];
          }

          this.setState({
            colorsToShow: colors[this.state.currentEditionSelected],
            optionsData: options[this.state.currentEditionSelected],
            currentVersionSelected: Object.keys(this.state.versionsToShow)[0],
            showViews: this.state.versionsToShow[Object.keys(this.state.versionsToShow)[0]].showViews ,
            seatRows: this.state.versionsToShow[Object.keys(this.state.versionsToShow)[0]].seatRows ,
            scenesData: scenes,
            currentSceneSelected: defaultSceneIndex
          }, () => {
            this.props.handleSelectModel(this.state.currentVersionSelected)
            this.setState({
              currentColorSelected: Object.keys(this.state.colorsToShow)[0]
            }, () => {
              this.props.handleChangeColor(this.state.currentColorSelected)
              if (defaultSceneObj) {
                this.props.handleChangeScene(defaultSceneObj)
              }
              window.dataLayer.push({
                'event': 'car_configuration_click',
                'comp_product': {
                'position': 'page',
                'vehicle_type': "car",
                'brand': "hyundai",
                'product_condition': "new",
                'model': this.props.currentCarSelected.toLowerCase(),
                'version': this.state.currentVersionSelected.toLowerCase(),
                'color': this.state.currentColorSelected.toLowerCase(),
                'upholstery': null,
                'accesories': null,
                'fuel_type': null,
                'price': null,
                'currency': "cop",
                }
              })

              //WEB GET PARAMS
              if(this.props.firstLoadedWebParams === true){
                this.props.handleFirstWebParams(false)
                if(params.color !== undefined) {
                  Object.keys(this.state.colorsToShow).forEach((key: any, index: number) => {
                    if( key.toLowerCase() === params.color.toLowerCase() ){
                      this.setState({
                        currentColorSelected: key
                      }, () => {
                        this.props.handleChangeColor(this.state.currentColorSelected)
                        window.sendDataByUrlParams("COLOR", this.props.currentCarSelected, this.state.currentVersionSelected, params.color.toUpperCase())
                      })
                    }
                  })
                }
  
                if(params.scenario !== undefined) {
                  Object.keys(this.state.scenesData).forEach((key: any, index: number) => {
                    if( key.toLowerCase() === params.scenario.toLowerCase() ){
                      this.setState({
                        currentSceneSelected: index
                      }, () => {
                        //can't send update until dome is first loaded...
                        var interval : any;
                        interval = setInterval( () => {
                          if(this.props.openScene){
                            this.props.handleChangeScene(this.state.scenesData[key])
                            window.sendDataByUrlParams("ESCENARIO", this.props.currentCarSelected, this.state.currentVersionSelected, params.scenario.toUpperCase())
                            clearInterval(interval)
                          }
                        }, 100)
                      })
                    }
                  })
                }
              }

            })
          })
        })
      })
    })
  }

  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {
    if(this.props.currentCarSelected !== prevProps.currentCarSelected && this.props.currentCarSelected !== ''){
      this.setState({
        versionsToShow: this.state.carData[this.props.currentCarSelected],
      }, () => {
        this.setState({
          currentEditionSelected: this.props.currentCarSelected +" "+ Object.keys(this.state.versionsToShow)[0]
        }, () => {
          var colors: any = colorsData()
          var options: any = optionsData()
          var scenes: any = sceneData(this.state.currentEditionSelected)
          this.props.handleCompleteCar(this.state.currentEditionSelected)

          let defaultSceneIndex = 0;
          let defaultSceneObj: any = null;
          if (scenes && Object.keys(scenes).length > 0) {
            const keys = Object.keys(scenes);
            const defKey = keys.find(k => scenes[k].default === true) || keys[0];
            defaultSceneIndex = keys.indexOf(defKey);
            defaultSceneObj = scenes[defKey];
          }

          this.setState({
            colorsToShow: colors[this.state.currentEditionSelected],
            optionsData: options[this.state.currentEditionSelected],
            currentVersionSelected: Object.keys(this.state.versionsToShow)[0],
            scenesData: scenes,
            currentSceneSelected: defaultSceneIndex
          }, () => {
            this.props.handleSelectModel(this.state.currentVersionSelected)
            this.setState({
              currentColorSelected: Object.keys(this.state.colorsToShow)[0]
            }, () => {
              this.props.handleChangeColor(this.state.currentColorSelected)
              if (defaultSceneObj) {
                this.props.handleChangeScene(defaultSceneObj)
              }
            })
          })
        })
      })
    }

    if(prevProps.openScene !== this.props.openScene){
      this.setState({
        isCollapsed: true
      }, () => {this.props.handleCollapse(this.state.isCollapsed)}
      )
    }
    if(prevProps.showVideo !== this.props.showVideo){
      if(this.props.showVideo){
        this.setState({
          isCollapsed: true,
          showArrow: false
        })
      }
      else{
        this.setState({
          isCollapsed: false,
          showArrow: true
        })
      }
    }
    if(prevProps.isCarStudioClosedQuotation !== this.props.isCarStudioClosedQuotation && this.props.isCarStudioClosedQuotation){
      this.handleCloseCarStudio();
    }
  }

  handleSelectOption = (payload: string) => {
    if(payload === 'ficha') {
    var tempFichasData: any = fichasData()
    var tempFichasNameData: any = fichasNameData()
    window.dataLayer.push({
      'event': 'file_download',
      'comp_page': {
      'file_name': tempFichasNameData[this.state.currentEditionSelected].toLowerCase(),
      'link': tempFichasData[this.state.currentEditionSelected].toLowerCase(),
      'vehiculo_type': "car",
      'brand': "hyundai",
      'product_condition': "new",
      'model': this.props.currentCarSelected.toLowerCase(),
      'file_type': 'catalog',
      'download_type': 'preview'
      }
    })
      // const tempLink = document.createElement('a')
      // tempLink.href = tempFichasData[this.state.currentEditionSelected]
      // tempLink.target = '_blank'
      // tempLink.click()

      this.props.handleShowPDF(true)
      
    }
    if(payload === 'modelo'){
      this.props.handleShowVideo(true)
      this.setState({
        showBullets: false,
      }, () => {
        this.props.handleShowBulletsInterior(false)
        this.props.handleShowBullets(false)
      })
    }
    if(payload === 'video'){
      this.props.handleIsVideoOpened(true)
    }
    if(payload === 'cotiza'){
      if(this.props.enableInternalCotizaGlobally === true){
        this.props.handleQuotation(!this.props.isQuotationOpened)
      }else{
        var cotizaLink : any = cotizaData()
        const tempLink = document.createElement('a')
        tempLink.href = cotizaLink[this.state.currentEditionSelected]
        tempLink.target = '_blank'
        tempLink.click()
      }
    }
  }

  handleViewConfiguration = () => {
    window.dataLayer.push({
      'event': 'car_configuration_view',
      'comp_product': {
      'vehicle_type': "car",
      'brand': "hyundai",
      'product_condition': "new",
      'model': this.props.currentCarSelected.toLowerCase(),
      'version': this.state.currentVersionSelected.toLowerCase(),
      'color': this.state.currentColorSelected.toLowerCase(),
      'upholstery': null,
      'accesories': null,
      'fuel_type': null,
      'price': null,
      'currency': "cop",
      'step': '1/1'
      }
    })
  }

  handleCloseCarStudio = () => {
    this.setState({ showBullets: false }, () => { this.props.handleShowBulletsInterior(false) ; this.props.handleShowBullets(false)})
    this.props.handleShowLigths(false)
    this.props.handleTurnOffLigths(false)
    this.props.handleCloseCarStudio()
    this.props.handleCarStudioFromQuotation(false)
  }

  render(): React.ReactNode {
    return(
      <React.Fragment>
        <div className={this.state.isCollapsed  ? 'car-studio-main-container-collapsed':'car-studio-main-container'} style={{
          }}>
            
            {params.lite !== "true" ?
              <div className='title-container'>
                <div className='car-studio-name'>
                  {getCarDisplayName(this.props.currentCarSelected, this.state.currentVersionSelected)}
                </div>
                {/* <div className='close-car-studio-btn' onClick={() => { this.handleCloseCarStudio() }}>
                  <img src={doubleArrowBtn} alt=''/>
                </div> */}
              </div>
            :
              <div style={{marginTop: "3rem"}}/>
            }
            {
              Object.keys(this.state.versionsToShow).length > 0 ?
              <div className='car-studio-versions-general-container'>
                <div className='car-studio-version-title'>Versiones</div>
                <div className='car-studio-versions-container'>
                  {
                    Object.keys(this.state.versionsToShow).map((version: any, index: number) => 
                    <div id='element-umbra-analytics' data-type={"VERSION"} data-value={this.props.currentCarSelected} data-child={version} data-second={version} className={this.state.currentVersionSelected === version ? 'car-studio-version-individual version-selected':'car-studio-version-individual'}>{getVersionDisplayName(this.props.currentCarSelected, version)}</div>
                    )
                  }
                </div>
              </div>:null
            }

            { ///vistas
              <div className='car-studio-versions-general-container'>
              <div className='vistas-car-studio-title'>
                Vistas
              </div>
              <div className='vistas-car-studio-container'>
                <div 
                className={this.state.currentSelectedVista === 0 ? 'vista-btn-container vista-selected':'vista-btn-container'} 
                id='element-umbra-analytics' data-type={"VISTA"} data-value={this.props.currentCarSelected} data-second={this.state.currentVersionSelected} data-child={"Exterior"} 
                onClick={
                    () => {
                      if (!this.props.isPlayingAnimation && this.state.currentSelectedVista !== 0) {
                        this.setState({
                          currentSelectedVista: 0,
                        }, () => {
                          this.props.handleShowInterior(false)
                          this.setState({
                            currentSeatSelected: 0,
                            showBullets: false
                          })
                          this.props.handleShowBulletsInterior(false)
                          this.props.handleShowBullets(false)
                          this.props.handleTurnOffLigths(false)
                        })
                      }
                    }
                  }>
                  Exterior
                </div>
                <div 
                className={this.state.currentSelectedVista === 1 ? 'vista-btn-container vista-selected':'vista-btn-container'} 
                id='element-umbra-analytics' data-type={"VISTA"} data-value={this.props.currentCarSelected} data-second={this.state.currentVersionSelected} data-child={"Interior"} 
                onClick={
                () => {
                  if (!this.props.isPlayingAnimation && this.state.currentSelectedVista !== 1) {
                    this.setState({
                      currentSelectedVista: 1,
                      showBullets: false,
                      currentSeatSelected: 0,
                    }, () => {
                      this.props.handleShowInterior(true)
                      this.props.handleShowBulletsInterior(false)
                      this.props.handleShowBullets(false)
                      this.props.handleTurnOffLigths(false)
                    })
                  }
              }
              }>
                  Interior
                </div>
              </div>
            </div>
            }

            { params.lite !== "true" &&
              <div className='switch-car-studio-caracteristic-container'>
              <Switch 
                onChange={() => {
                  this.setState({
                    showBullets: !this.state.showBullets
                  }, () => {
                    this.state.currentSelectedVista === 1 ?
                    this.props.handleShowBulletsInterior(this.state.showBullets):
                    this.props.handleShowBullets(this.state.showBullets)
                  })
                }} 
                offColor = '#000000'
                onColor = '#000000'
                onHandleColor = '#05A3E1'
                offHandleColor = '#ffffff'
                checked={this.state.showBullets}
                uncheckedIcon = {false}
                checkedIcon = {false}
                activeBoxShadow = {'0px 0px 3px #05A3E1'}
                handleDiameter={16}
                height={23}
                width={42}
                className='switch-input'
              />
              <div className='switch-car-studio-title'>Mostrar características</div>
            </div>
            }

            <hr className='hr-car-studio'/>

            {
              Object.keys(this.state.scenesData).length > 0 ?
              <div className='scenes-general-container'>
                <div className='scenes-general-title'>Escenarios</div>
                <div className='scenes-container'>
                  {
                    Object.keys(this.state.scenesData).map((scenes: any, index: number) => 
                      <div className='options-container-text'>
                        <div 
                        className={this.state.currentSceneSelected === index ? 'scenes-individual-container vista-selected':'scenes-individual-container'} 
                        id='element-umbra-analytics' data-type={"ESCENARIO"} data-value={this.props.currentCarSelected} data-second={this.state.currentVersionSelected} data-child={this.state.scenesData[scenes].name} 
                        onClick={() => {
                          if(!this.state.disableSceneButtons){
                            this.setState({
                              //disableSceneButtons: true,
                              currentSceneSelected: index
                            }, () => {
                              this.props.handleChangeScene(this.state.scenesData[scenes])
                            })
                            setTimeout(() => {
                              this.setState({
                                disableSceneButtons: false,
                              })
                            }, 1100);
                          }
                        }}
                        >
                          <img id='element-umbra-analytics' data-type={"ESCENARIO"} data-value={this.props.currentCarSelected} data-second={this.state.currentVersionSelected} data-child={this.state.scenesData[scenes].name}  src={this.state.scenesData[scenes].icon.default} alt=''/>
                        </div>
                        <div className='options-individual-name'>{this.state.scenesData[scenes].name}</div>
                      </div>
                    )
                  }
                </div>
              </div>:null
            }

            {
              Object.keys(this.state.colorsToShow).length > 0 && this.state.currentSelectedVista === 0 ?
              <div className='colors-general-container'>
                <div className='scenes-general-title'>Color</div>
                <div className='colors-container'>
                  {
                    Object.keys(this.state.colorsToShow).map((color: any) =>
                      <div 
                        className={this.state.currentColorSelected === color ? 'colors-individual-container color-selected':'colors-individual-container'}
                        id='element-umbra-analytics' data-type={"COLOR"} data-value={this.props.currentCarSelected} data-second={this.state.currentVersionSelected} data-child={this.state.colorsToShow[color].name} 
                        onClick={() => {
                          if(!this.state.disableColorButtons){
                            this.setState({
                              //disableColorButtons: true,
                              currentColorSelected: color
                            }, () => {
                              this.props.handleChangeColor(color)
                            })
                            setTimeout(() => {
                              this.setState({
                                disableColorButtons: false,
                              })
                            }, 1100);
                          }
                          }}
                        style={{
                          backgroundImage: `url(${this.state.colorsToShow[color].Image})`
                        }}
                      >
                        <img id='element-umbra-analytics' data-type={"COLOR"} data-value={this.props.currentCarSelected} data-second={this.state.currentVersionSelected} data-child={this.state.colorsToShow[color].name}  src={this.state.colorsToShow[color].Image} alt=''/>
                      </div>
                    )
                  }
                </div>
                <div className='current-color-name'>
                  {this.state.currentColorSelected !== '' && this.state.colorsToShow[this.state.currentColorSelected] ? this.state.colorsToShow[this.state.currentColorSelected].name:''}
                </div>
              </div>:null
            }

            {this.state.currentSelectedVista === 0 && params.lite !== "true" && getConfigData().encender_vehiculo ?
              <div className='switch-car-studio-caracteristic-container'>
                <Switch
                  onChange={()  => {
                    this.setState({
                      disableExteriorSwitchLights: true,
                    }, () => {
                      this.props.handleTurnOffLigths(!this.props.showLigths)
                      this.props.handleShowLigths(!this.props.showLigths)
                    })
                    setTimeout(() => {
                      this.setState({
                        disableExteriorSwitchLights: false,
                      })
                    }, 2100);
                  }} 
                  disabled={this.state.disableExteriorSwitchLights || this.props.isPlayingAnimation}
                  offColor = '#000000'
                  onColor = '#000000'
                  onHandleColor = {'#05A3E1'}
                  offHandleColor = {'#ffffff'}
                  checked={this.props.showLigths}
                  uncheckedIcon = {false}
                  checkedIcon = {false}
                  activeBoxShadow = {'0px 0px 3px #05A3E1'}
                  handleDiameter={16}
                  height={23}
                  width={42}
                  className='switch-input'
                />
                <div className='switch-car-studio-title'>Luces del vehículo</div>
              </div>:null
            }

            {
              this.state.currentSelectedVista === 1 && this.state.showViews ?
              <div className='seat-distribution-container'>
                <div className='seat-distribution-title'>Distribución de sillas</div>
                
                { this.state.seatRows === 1 && //1 seat row
                  <div className='seat-distribution-general-container'>
                  <div 
                    className={this.state.currentSeatSelected === 0 ? 'seat seat-front-left seat-selected':'seat seat-front-left'} 
                    id='element-umbra-analytics' data-type={"SILLAS"} data-value={this.props.currentCarSelected} data-second={this.state.currentVersionSelected} data-child={"Piloto"} 
                    onClick={
                      () => {
                        if (!this.props.isPlayingAnimation) {
                          this.setState({currentSeatSelected: 0}, () => {this.props.handleChangeSeat('FL')})
                        }
                      }
                    }
                  ></div>
                  <div 
                  className={this.state.currentSeatSelected === 1 ? 'seat seat-front-right seat-selected':'seat seat-front-right'} 
                  id='element-umbra-analytics' data-type={"SILLAS"} data-value={this.props.currentCarSelected} data-second={this.state.currentVersionSelected} data-child={"Copiloto"} 
                  onClick={
                    () => {
                      if (!this.props.isPlayingAnimation) {
                        this.setState({currentSeatSelected: 1}, () => {this.props.handleChangeSeat('FR')})
                      }
                    }
                    }></div>
                </div>}
                { this.state.seatRows === 2 && //2 seat rows
                  <div className='seat-distribution-general-container'>
                  <div 
                    className={this.state.currentSeatSelected === 0 ? 'seat seat-front-left seat-selected':'seat seat-front-left'} 
                    id='element-umbra-analytics' data-type={"SILLAS"} data-value={this.props.currentCarSelected} data-second={this.state.currentVersionSelected} data-child={"Piloto"} 
                    onClick={
                      () => {
                        if (!this.props.isPlayingAnimation) {
                          this.setState({currentSeatSelected: 0}, () => {this.props.handleChangeSeat('FL')})
                        }
                      }
                    }
                  ></div>
                  <div 
                  className={this.state.currentSeatSelected === 1 ? 'seat seat-front-right seat-selected':'seat seat-front-right'} 
                  id='element-umbra-analytics' data-type={"SILLAS"} data-value={this.props.currentCarSelected} data-second={this.state.currentVersionSelected} data-child={"Copiloto"} 
                  onClick={
                    () => {
                      if (!this.props.isPlayingAnimation) {
                        this.setState({currentSeatSelected: 1}, () => {this.props.handleChangeSeat('FR')})
                      }
                    }
                    }></div>
                  <div 
                  className={this.state.currentSeatSelected === 2 ? 'seat seat-back-left seat-selected':'seat seat-back-left'} 
                  id='element-umbra-analytics' data-type={"SILLAS"} data-value={this.props.currentCarSelected} data-second={this.state.currentVersionSelected} data-child={"Pasajero 1"} 
                  onClick={
                    () => {
                      if (!this.props.isPlayingAnimation) {
                        this.setState({currentSeatSelected: 2}, () => {this.props.handleChangeSeat('BL')})
                      }
                    }
                    }></div>
                  <div 
                  className={this.state.currentSeatSelected === 3 ? 'seat seat-back-right seat-selected':'seat seat-back-right'} 
                  id='element-umbra-analytics' data-type={"SILLAS"} data-value={this.props.currentCarSelected} data-second={this.state.currentVersionSelected} data-child={"Pasajero 2"} 
                  onClick={
                    () => {
                      if (!this.props.isPlayingAnimation) {
                        this.setState({currentSeatSelected: 3}, () => {this.props.handleChangeSeat('BR')})
                      }
                    }
                    }></div>
                </div>}

                { this.state.seatRows === 3 && //3 seat rows
                  <div className='seat-distribution-general-container'>
                  <div 
                    className={this.state.currentSeatSelected === 0 ? 'seat seat-front-left seat-selected':'seat seat-front-left'} 
                    id='element-umbra-analytics' data-type={"SILLAS"} data-value={this.props.currentCarSelected} data-second={this.state.currentVersionSelected} data-child={"Piloto"} 
                    onClick={
                      () => {
                        if (!this.props.isPlayingAnimation) {
                          this.setState({currentSeatSelected: 0}, () => {this.props.handleChangeSeat('FL')})
                        }
                      }
                    }
                  ></div>
                  <div 
                  className={this.state.currentSeatSelected === 1 ? 'seat seat-front-right seat-selected':'seat seat-front-right'} 
                  id='element-umbra-analytics' data-type={"SILLAS"} data-value={this.props.currentCarSelected} data-second={this.state.currentVersionSelected} data-child={"Copiloto"} 
                  onClick={
                    () => {
                      if (!this.props.isPlayingAnimation) {
                        this.setState({currentSeatSelected: 1}, () => {this.props.handleChangeSeat('FR')})
                      }
                    }
                    }></div>
                  <div 
                  className={this.state.currentSeatSelected === 2 ? 'seat seat-middle-left seat-selected':'seat seat-middle-left'} 
                  id='element-umbra-analytics' data-type={"SILLAS"} data-value={this.props.currentCarSelected} data-second={this.state.currentVersionSelected} data-child={"Pasajero 1"} 
                  onClick={
                    () => {
                      if (!this.props.isPlayingAnimation) {
                        this.setState({currentSeatSelected: 2}, () => {this.props.handleChangeSeat('BL')})
                      }
                    }
                    }></div>
                  <div 
                  className={this.state.currentSeatSelected === 3 ? 'seat seat-middle-right seat-selected':'seat seat-middle-right'} 
                  id='element-umbra-analytics' data-type={"SILLAS"} data-value={this.props.currentCarSelected} data-second={this.state.currentVersionSelected} data-child={"Pasajero 2"} 
                  onClick={
                    () => {
                      if (!this.props.isPlayingAnimation) {
                        this.setState({currentSeatSelected: 3}, () => {this.props.handleChangeSeat('BR')})
                      }
                    }
                    }></div>
                    <div 
                  className={this.state.currentSeatSelected === 4 ? 'seat seat-back-left seat-selected':'seat seat-back-left'} 
                  id='element-umbra-analytics' data-type={"SILLAS"} data-value={this.props.currentCarSelected} data-second={this.state.currentVersionSelected} data-child={"Pasajero 3"} 
                  onClick={
                    () => {
                      if (!this.props.isPlayingAnimation) {
                        this.setState({currentSeatSelected: 4}, () => {this.props.handleChangeSeat('BL2')})
                      }
                    }
                    }></div>
                  <div 
                  className={this.state.currentSeatSelected === 5 ? 'seat seat-back-right seat-selected':'seat seat-back-right'} 
                  id='element-umbra-analytics' data-type={"SILLAS"} data-value={this.props.currentCarSelected} data-second={this.state.currentVersionSelected} data-child={"Pasajero 4"} 
                  onClick={
                    () => {
                      if (!this.props.isPlayingAnimation) {
                        this.setState({currentSeatSelected: 5}, () => {this.props.handleChangeSeat('BR2')})
                      }
                    }
                    }></div>
                </div>}

              </div>:null
            }

           { params.lite !== "true" && getConfigData().encender_vehiculo && <hr className='hr-car-studio'/>}
            {this.state.currentSelectedVista === 1 && params.lite !== "true" && getConfigData().encender_vehiculo ?
              <div className='switch-car-studio-caracteristic-container interior-ligths-switch'>
                <Switch
                  onChange={() => {
                    this.setState({
                      disableInteriorSwitchLights: true,
                    }, () => {
                      this.props.handleTurnOffLigths(!this.props.showInteriorLights)
                      this.props.handleShowInteriorLights(!this.props.showInteriorLights)
                    })
                    setTimeout(() => {
                      this.setState({
                        disableInteriorSwitchLights: false,
                      })
                    }, 2100);
                    
                  }}
                  disabled={this.state.disableInteriorSwitchLights || this.props.isPlayingAnimation}
                  offColor = '#000000'
                  onColor = '#000000'
                  onHandleColor = {'#05A3E1'}
                  offHandleColor = {'#ffffff'}
                  checked={this.props.showInteriorLights}
                  uncheckedIcon = {false}
                  checkedIcon = {false}
                  activeBoxShadow = {'0px 0px 3px #05A3E1'}
                  handleDiameter={16}
                  height={23}
                  width={42}
                  className='switch-input'
                />
                <div className='switch-car-studio-title'>Luces del interior</div>
              </div>:null
            }

            {
              Object.keys(this.state.optionsData).length > 0 && params.lite !== "true" ?
              <div className='options-general-container'>
                
                  {
                    Object.keys(this.state.optionsData).map((option: any) => 
                    this.state.currentSelectedVista === 0 || option !== 'PRESENTACION' ?
                      <div className='options-container-text'>
                        <div className='options-individual-container' 
                          id='element-umbra-analytics' data-type={"OPCIONES"} data-value={this.props.currentCarSelected} data-second={this.state.currentVersionSelected} data-child={this.state.optionsData[option].name} 
                          onClick={() => { if(!this.props.isPlayingAnimation){
                            this.handleSelectOption(this.state.optionsData[option].slug)}}
                            }>
                          <img id='element-umbra-analytics' data-type={"OPCIONES"} data-value={this.props.currentCarSelected} data-second={this.state.currentVersionSelected} data-child={this.state.optionsData[option].name} src={this.state.optionsData[option].Icon.default} alt=''/>
                        </div>
                        <div className='options-individual-name'>{this.state.optionsData[option].name}</div>
                      </div> : null
                    )
                  }
                
              </div>:null 
            }

            {params.lite !== "true" ?
              <div className='logo-umbra-container'>
                <a href='https://www.umbraint.com/' target='_blank' rel="noreferrer">
                <img src={logoUmbra} alt=''/>
                </a>
              </div>
            :
              <div style={{marginTop: "3rem"}}/>
            }

          </div>
          <div className={!this.state.showArrow ? 'car-studio-collapse-btn fade-out':this.state.isCollapsed && this.state.showArrow ? `car-studio-collapse-btn ${params.lite !== "true" ? '' : 'lite'}`:`car-studio-collapse-btn-uncollapsed ${params.lite !== "true" ? '' : 'lite'}`} onClick={() => {this.setState({isCollapsed: !this.state.isCollapsed}, () => {this.handleViewConfiguration(); this.props.handleCollapse(this.state.isCollapsed)} )}}>
            <img src={arrowBtn} alt=''/>
          </div>
      </React.Fragment>
    )
  }
}

export default CarStudioUI